function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import z from 'zod';
import { FiAlignCenter } from 'react-icons/fi/index.js';
import link from '../objects/link.js';
import textAlignment from '../objects/textAlignment.js';
import columnInfoGroup from '../objects/columnInfoGroup.js';
import mediaSection from '../objects/mediaSection.js';
import simpleDatalistSection from '../objects/simpleDatalistSection.js';
import callToActionsBlock from '../objects/callToActionsBlock.js';
var fragment = {
    type: 'array',
    of: [
        {
            type: 'block',
            marks: {
                annotations: [
                    link.schema.object,
                    _object_spread_props(_object_spread({}, textAlignment.schema.object), {
                        icon: FiAlignCenter
                    })
                ],
                decorators: [
                    {
                        title: 'Bold',
                        value: 'strong'
                    },
                    {
                        title: 'Emphasis',
                        value: 'em'
                    }
                ]
            }
        },
        {
            type: 'mediaSection',
            title: mediaSection.schema.object.title
        },
        {
            type: 'columnInfoGroup',
            title: columnInfoGroup.schema.object.title
        },
        {
            type: 'simpleDatalistSection',
            title: simpleDatalistSection.schema.object.title
        },
        {
            type: 'callToActionsBlock',
            title: callToActionsBlock.schema.object.title
        }
    ]
};
var validator = z.array(z.unknown()).refine(function(value) {
    return true;
});
export default {
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=blockContent.js.map